import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { tap, timeout } from 'rxjs/operators';
import { LabMDM } from '../masterdata/models/lab';
import { BBResponseContainer } from '../common-services/response-container';
import { InboundFileProcessing } from '../masterdata/models/InboundFileProcessing';

@Injectable({
  providedIn: 'root'
})
export class MdmInboundFileProcessingService {

  readonly MACHINEMDMSERVICE = 'admin/mdm/machine';
  readonly INBOUNDMDMSERVICE = 'admin/mdm/inboundFileProcessing';

  constructor(private http: HttpClient) {}

  getMachineByLab(lab:LabMDM, active: boolean): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + this.MACHINEMDMSERVICE+ "/activeMachine";
    let requestParam = new HttpParams().set('labId', lab._id).set('active', active.toString());
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    }));
  }
  //Creates a new Inbound File
  addInboundFileData(inboundData: InboundFileProcessing) :  Observable<BBResponseContainer>{
    let url: string = environment.BB_MDMSERVICE_URL + this.INBOUNDMDMSERVICE + "/saveInBoundData";
    return this.http.post<BBResponseContainer>(url, inboundData).pipe(timeout(environment.defaultTimeout));
  }

  //updates a businessArea
  updateInboundFileData(inboundData: InboundFileProcessing) {
    let url: string = environment.BB_MDMSERVICE_URL + this.INBOUNDMDMSERVICE + "/updateInBoundData";
    return this.http.put<BBResponseContainer>(url, inboundData).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    }));
}
}
